export default "/images/vendor/@coreui/icons/svg/flag/cif-ch.svg?48cb09318e82023bd7ff5ceabcdebf2a";